import { ImageLoaderConfig } from '@angular/common';
import { InjectionToken } from '@angular/core';
import { IResizeOptions, IResizeOptions as IResizeOptionsCore } from '@df/ui/common/resize.service';

export namespace NCloudflare {
    export const DEFAULT_OPTIONS = {
        defaultOptions: {
            fillColor: 'FFFFFF'
        }
    };

    export const OPTIONS = new InjectionToken<IModuleOptions>('DF_CLOUDFLARE_OPTIONS', {
        providedIn: 'root',
        factory: () => DEFAULT_OPTIONS
    });

    export interface IModuleOptions {
        defaultOptions: Partial<IResizeOptions>;
    }

    export interface ILoaderConfig extends ImageLoaderConfig {
        loaderParams: IResizeOptionsCore;
    }
}

declare module '@df/ui/common/resize.service' {
    interface IResizeOptions {
        fitIn?: boolean | string;
        fillColor?: string;
        cropType?: string;
        verticalCrop?: string;
        horizontalCrop?: string;
        trim?: boolean | number | string;
        // whole setting string as described: https://developers.cloudflare.com/images/image-resizing/resize-with-workers
        sharpen?: number | string | false;
        upscale?: boolean;
        quality?: number | false;
        format?: 'jpeg' | 'webp' | 'gif' | 'png';
    }
}
